import axios from 'axios';

// Get the data from ther server and return it
const fetchListsData = async (url) => {
	try {
		const response = await axios.get(url);
		return response.data;
	} catch (error) {
		// eslint-disable-next-line no-console
		console.error('Error fetching data:', error);
		throw error;
	}
};

// Generates a dictionary of all the places in a blog and the lists that contain them
// {placeId1: [listId1, listId2, ...]}
// This dictionary is stored in session storage
const generatePlaceDictionary = (placeList) => {
	const userLists = JSON.parse(sessionStorage.getItem('userLists'));

	const placeDictionary = {};

	placeList.forEach((place) => {
		placeDictionary[place] = [];

		userLists.forEach((list) => {
			if (list.places.includes(place))
				placeDictionary[place].push(list.id);
		});
	});

	sessionStorage.setItem('placeDictionary', JSON.stringify(placeDictionary));
};

//  Generates a payload for the patch request, determines if the modification was add or delete
// Creates updateMessage for update banner and returns the updatePayload and updateType for later use
const getUpdatedPayload = (placeList, placeId, placeName, listName) => {
	let updateMessage = '';

	// If the placeList includes the placeId, delete place from list, else, add to list
	if (placeList.includes(placeId)) {
		const index = placeList.indexOf(placeId);
		placeList.splice(index, 1);
		sessionStorage.setItem(
			'updateMessage',
			`${placeName} ha sido borrado de la lista: ${listName}`
		);
		updateMessage = `${placeName} ha sido borrado de la lista: ${listName}`;
	} else {
		placeList.push(placeId);
		sessionStorage.setItem(
			'updateMessage',
			`${placeName} ha sido guardado en la lista: ${listName}`
		);
		updateMessage = `${placeName} ha sido guardado en la lista: ${listName}`;
	}
	return [{ places: placeList }, updateMessage];
};

const showAnnouncement = (message) => {
	(() => {
		const updateBanner = document.getElementById('list-update-banner');
		const updateBannerMessage = document.getElementById('message');
		updateBannerMessage.textContent = message;

		function showBanner() {
			updateBanner.style.bottom = '0';
		}

		function hideBanner() {
			updateBanner.style.bottom = '-120px';
		}

		showBanner();
		setTimeout(function () {
			hideBanner();
			updateBannerMessage.textContent = '';
		}, 4000); // Delay in milliseconds (4 seconds in this case)
	})(jQuery);
};

export {
	fetchListsData,
	getUpdatedPayload,
	showAnnouncement,
	generatePlaceDictionary,
};
